const initSiteHeader = () => {
  const header = document.querySelector('[data-module="site-header"]')

  if (! header) {
    return
  }

  const toggle = header.querySelector('[data-site-header-toggle]')
  const panel = header.querySelector('[data-site-header-panel]')
  const close = header.querySelector('[data-site-header-close]')
  const overlay = header.querySelector('[data-site-header-overlay]')
  const logo = header.querySelector('.site-header__logo')
  const links = panel ? panel.querySelectorAll('a') : []
  const stickyThreshold = 120

  const syncSticky = () => {
    const sticky = window.scrollY > stickyThreshold

    header.classList.toggle('is-sticky', sticky)

    if (logo) {
      const defaultLogo = logo.getAttribute('data-logo-default')
      const lightLogo = logo.getAttribute('data-logo-light')
      logo.src = sticky ? defaultLogo : lightLogo
    }
  }

  syncSticky()

  if (! toggle || ! panel) {
    window.addEventListener('scroll', syncSticky, { passive: true })
    return
  }

  const setOpen = (open) => {
    header.classList.toggle('is-open', open)
    document.body.classList.toggle('has-mobile-nav-open', open)
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
    panel.setAttribute('aria-hidden', open ? 'false' : 'true')
  }

  toggle.addEventListener('click', () => {
    setOpen(! header.classList.contains('is-open'))
  })

  if (close) {
    close.addEventListener('click', () => {
      setOpen(false)
    })
  }

  if (overlay) {
    overlay.addEventListener('click', () => {
      setOpen(false)
    })
  }

  links.forEach((link) => {
    link.addEventListener('click', () => {
      if (window.innerWidth <= 1200) {
        setOpen(false)
      }
    })
  })

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setOpen(false)
    }
  })

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1200) {
      setOpen(false)
    }
  })

  window.addEventListener('scroll', syncSticky, { passive: true })
}

export default initSiteHeader



// WEBPACK FOOTER //
// ./resources/assets/js/components/site-header.js